const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL?.replace(/\/$/, ''),
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL
  },
  appName: process.env.REACT_APP_NAME
};

export default config;